// ** Third Party Components
import styled, { css } from "styled-components";

export const StyledSvgIconContainer = styled.span`
	display: inline-flex;
	align-items: center;
	justify-content: center;
	width: 18px;
	margin: 0 0.5rem 0 0;

	${({ $customMargin }) =>
		$customMargin &&
		css`
			margin: ${$customMargin};
		`}

	${({ $customWidth }) =>
		$customWidth &&
		css`
			width: ${$customWidth};
		`}

	svg {
		fill: ${({ theme: { colors } }) => colors.whiteAlways};
		display: block;
		height: 1em;

		${({ $customHeight }) =>
			$customHeight &&
			css`
				height: ${$customHeight};
			`};

		${({ $customVerticalAlign }) =>
			$customVerticalAlign &&
			css`
				vertical-align: ${$customVerticalAlign};
			`};
	}
`;
const SexIcon = ({
	customHeight,
	customMargin,
	customVerticalAlign,
	customWidth,
}) => {
	return (
		<StyledSvgIconContainer
			$customHeight={customHeight}
			$customMargin={customMargin}
			$customVerticalAlign={customVerticalAlign}
			$customWidth={customWidth}
		>
			<svg
				viewBox="0 0 14 14"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
			>
				<path
					d="M6.32727 6.65825C6.30626 5.6641 6.09558 4.68312 5.70656 3.76801C3.22375 4.92739 1.39992 7.11489 0.776487 9.69614C1.14134 10.5321 1.67043 11.2862 2.33235 11.9137C2.96188 9.72494 4.38675 7.85048 6.32727 6.65825ZM5.31828 2.98325C4.90242 2.25867 4.37244 1.60589 3.74875 1.05004C1.26047 2.41176 -0.210623 5.2309 0.330784 8.21957C1.24406 5.94731 3.02141 4.06332 5.31828 2.98325ZM10.448 7.4977C10.6831 4.76879 9.70149 2.09731 7.78196 0.268011C7.38 0.221527 6.37102 0.11762 5.07766 0.500433C6.65989 2.14011 7.57182 4.31215 7.6343 6.58989C8.50567 7.06926 9.46075 7.37741 10.448 7.4977ZM7.03821 7.75746C6.18771 8.27381 5.44343 8.94756 4.84524 9.74262C7.08742 11.3094 9.89016 11.7961 12.4331 11.0497C12.9801 10.3167 13.3726 9.48047 13.587 8.59145C12.8639 8.77569 12.1211 8.87119 11.3749 8.87582C9.88196 8.87309 8.39719 8.49028 7.03821 7.75746ZM4.35032 10.4836C3.93469 11.1946 3.64758 11.9711 3.47258 12.786C4.68557 13.5303 6.10263 13.8727 7.52166 13.7642C8.94069 13.6556 10.2892 13.1018 11.3749 12.1817C8.28782 12.6219 5.81594 11.5036 4.35032 10.4836ZM9.28039 0.62348C10.7925 2.54848 11.5363 5.03129 11.3202 7.55785C12.1533 7.55961 12.9812 7.42854 13.773 7.16957C13.773 7.11489 13.7812 7.0602 13.7812 7.00551C13.7812 4.05786 11.9027 1.56137 9.28039 0.62348Z"
					fill="#FFCB18"
				/>
			</svg>
		</StyledSvgIconContainer>
	);
};

export default SexIcon;
